import React from 'react'

import { HORIZONTAL_TEMPLATE } from '../../_templates/Templates'
import { Label } from '../../../../../packages/kiti/components/presentation/Text'
import {
  usePdfOptionsForm,
  usePdfOptionsFormActions
} from '../../../../../components/pdf/options/_form/PdfOptionsFormHandler'
import Separator from '../../../../../packages/kiti/components/helpers/Separator'
import TextArea from '../../../../../packages/kiti/components/form/Textarea'
import SliderInput from '../../../../../components/form/SliderInput'
import { FlexCol } from '../../../../../components/structure/FlexGrid'
import Accordion from '../../../../../components/structure/accordion/Accordion'
import AccordionHeader from '../../../../../components/structure/accordion/AccordionHeader'
import Grid from '../../../../../components/pdf/Grid'
import { Title } from '../../../../../components/presentation/Text'
import AccordionContent from '../../../../../components/structure/accordion/AccordionContent'
import PopoverColorPicker from '../../../../../components/form/PopoverColorPicker'
import Select from '../../../../../packages/kiti/components/form/Select'

const SubtitleSection = () => {
  const form = usePdfOptionsForm()
  const { handleChange } = usePdfOptionsFormActions()

  if (![HORIZONTAL_TEMPLATE].includes(form.template)) return false

  const SUBTITLE_ALIGN_OPTIONS = [
    { name: 'À esquerda', id: 'left' },
    { name: 'Centralizado', id: 'center' },
    { name: 'À direita', id: 'right' },
    { name: 'Justificado', id: 'justify' }
  ]

  return (
    <FlexCol>
      <Accordion lineBorder mediumPadding={true} noRadius>
        <AccordionHeader>
          <Grid justify="space-between">
            <Title size="h6" noMargin>
              Subtítulo
            </Title>
          </Grid>
        </AccordionHeader>
        <AccordionContent>
          <Label color="black">Conteúdo</Label>
          <TextArea rows={2} value={form.subtitle} onChange={handleChange(`subtitle`)} />

          <Separator weight={3} />

          <Label color="black">Cor do Subtítulo</Label>
          <PopoverColorPicker
            value={form.subtitleColor}
            color={form.subtitleColor}
            onChange={handleChange(`subtitleColor`)}
          />

          <Separator weight={3} />

          <Label color="black">Tamanho da Fonte (px)</Label>
          <SliderInput value={form.subtitleSize} onChange={handleChange('subtitleSize')} step="1" min="10" max="40" />
          <Separator weight={3} />
          <Label color="black">Espaçamento superior (cm)</Label>
          <SliderInput
            value={form.subtitleSpacing}
            onChange={handleChange('subtitleSpacing')}
            step="0.05"
            min="0"
            max="10"
          />

          <Separator weight={3} />

          <Label color="black">Alinhamento</Label>
          <Select
            disablePagination
            onChange={handleChange('subtitleAlign')}
            value={form.subtitleAlign}
            disableEmptyOption
            options={SUBTITLE_ALIGN_OPTIONS}
          />
        </AccordionContent>
      </Accordion>
    </FlexCol>
  )
}

export default SubtitleSection
